import { render } from "./m25Final4.vue?vue&type=template&id=19d1d5a2&scoped=true"
import script from "./m25Final4.vue?vue&type=script&lang=js"
export * from "./m25Final4.vue?vue&type=script&lang=js"

import "./m25Final4.vue?vue&type=style&index=0&id=19d1d5a2&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d1d5a2"]])

export default __exports__